import { ChangeDetectionStrategy, Component, Injector, OnInit } from "@angular/core";
import { BaseRoutedComponent } from "@common/ux/base-routed.component";
import { CulturalDataFilterParamKeys } from "../../cultural-data-filter";
import { CulturalIndexAnalysisFilter } from "../cultural-index-analysis-filter";
import { CulturalIndexFilterService } from "../cultural-index-filter/cultural-index-filter.service";

@Component({
    selector: "adapt-ci-timeline-page",
    templateUrl: "./ci-timeline-page.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class CulturalIndexTimelinePageComponent extends BaseRoutedComponent implements OnInit {
    public readonly CareerValuationFilterParamKeys = Object.values(CulturalDataFilterParamKeys);

    public filterParameters = CulturalIndexAnalysisFilter.getDefaultFilterParameters();

    public constructor(
        public filterService: CulturalIndexFilterService,
        injector: Injector,
    ) {
        super(injector);

        this.filterService.reset();
    }

    public ngOnInit() {
        this.notifyActivated();
    }
}
